import * as Sentry from '@sentry/remix';

import { ensurePixelIsLoaded } from '~/utils/pixels';

// https://developers.facebook.com/docs/meta-pixel/implementation/conversion-tracking/
enum StandardEventNames {
  AddToCart = 'AddToCart',
  PageView = 'PageView',
  Purchase = 'Purchase',
  ViewContent = 'ViewContent'
}

enum CustomEventNames {
  AddPaymentInfo = 'AddPaymentInfo',
  CompleteRegistration = 'CompleteRegistration',
  InitiateCheckout = 'InitiateCheckout',
  InterstitialViewContent = 'InterstitialViewContent',
  NotifyMeSet = 'NotifyMeSet'
}

type StandardEvent = {
  data?: unknown;
  eventID: string;
  eventName: StandardEventNames;
};

export async function fireEvent({
  eventName,
  eventID,
  data = {}
}: StandardEvent) {
  try {
    if (!(await ensurePixelIsLoaded('fbq'))) return;

    window.fbq('consent', 'grant');
    window.fbq('track', eventName, data, { eventID });
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Failed to fire Facebook pixel event' }
    });
  }
}

export async function fireCustomEvent(
  eventName: CustomEventNames,
  data?: unknown,
  eventID?: string
) {
  try {
    if (!(await ensurePixelIsLoaded('fbq'))) return;

    window.fbq('consent', 'grant');
    window.fbq(
      'trackCustom',
      eventName,
      data,
      ...(eventID ? [{ eventID }] : [])
    );
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: 'Failed to fire Facebook custom pixel event' }
    });
  }
}

export default {
  CustomEventNames,
  StandardEventNames,
  fireCustomEvent,
  fireEvent
};
